import React, { Key } from 'react';
import { WdiCardTitle } from '@/components/WdiControls';
import { CloseOutlined } from '@ant-design/icons';
import { WdiPanel } from '@/components/WdiControls/WdiPanel';
import { Popover } from 'antd';
export type SelectedAppProps = {
  onDelete?: (key: Key) => void;
  data?: any;
};
const SelectedApp: React.FC<SelectedAppProps> = (props) => {
  const { data, onDelete } = props;
  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <WdiPanel title={<WdiCardTitle title="已选择" />}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '8px',
              alignItems: 'center',
              maxHeight: '200px', // 固定网格容器的高度
              overflowY: 'auto', // 超出时显示垂直滚动条
              boxSizing: 'border-box',
              width: '100%', // 确保宽度自适应
              overflowX: 'hidden', // 禁止横向滚动条
            }}
          >
            {data.map((item: any) => (
              <div
                key={item.soldToRealCode ? item.soldToRealCode : item.shipToCode}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between', // 将内容分开到两侧
                  height: '30px', // 压缩每个项的高度
                  padding: '4px 8px', // 减少内边距
                  boxSizing: 'border-box',
                  border: '1px solid #f0f0f0',
                  borderRadius: '4px',
                  backgroundColor: '#fafafa',
                  overflow: 'hidden', // 隐藏超出部分
                }}
              >
                <Popover
                  placement="topLeft"
                  content={
                    item.codeOrName && item.codeOrName.length > 10 ? (
                      <div style={{ maxWidth: 250, wordBreak: 'break-all' }}>{item.codeOrName}</div>
                    ) : undefined
                  }
                >
                  <span
                    style={{
                      flex: 1,
                      marginRight: '8px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: 'calc(100% - 60px)', // 留出按钮的宽度
                    }}
                  >
                    {item.codeOrName}
                  </span>
                </Popover>
                <CloseOutlined
                  onClick={() =>
                    onDelete?.(item.soldToRealCode ? item.soldToRealCode : item.shipToCode)
                  }
                  style={{
                    flexShrink: 0, // 禁止按钮缩小
                    whiteSpace: 'nowrap', // 禁止按钮文本换行
                  }}
                >
                  删除
                </CloseOutlined>
              </div>
            ))}
          </div>
        </WdiPanel>
      </div>
    </>
  );
};
export default SelectedApp;
